import { render, staticRenderFns } from "./Datatable.vue?vue&type=template&id=1a674c92&scoped=true&"
import script from "./Datatable.vue?vue&type=script&lang=ts&"
export * from "./Datatable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a674c92",
  null
  
)

export default component.exports